// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeImageBlockAddPage_wrapper__gpoIM"};